/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content{min-width:300px;height:50px}.abs{position:absolute}.long{position:absolute;height:400px;width:100px;background:#00d5ff}"];
export { styles as styles };
